<template>
    <div>

        <div class="agreement" v-if="lang==='ru'">
            <h1>Пользовательское соглашение для Соискателей </h1>


            <br>
            <p>
                Настоящее Пользовательское соглашение (далее - «Соглашение») регулирует
                отношения по использованию WEB-сайта в сети Интернет с адресом
        http://www.vcv.ru (далее - «Сайт») между        <strong>Обществом с ограниченной</strong>
                <strong>
                    ответственностью «Новые Информационные Системы», ИНН 7707734464
                </strong>
                (именуемым в дальнейшем
                <br/>
            </p>
            <p>
                «Исполнитель») и физическим лицом, использующим Сайт в целях поиска
                работы (именуемым в дальнейшем «Соискатель»).
            </p>
            <p>
                При регистрации на Сайте Соискатель соглашается с условиями настоящего
                Соглашения и принимает на себя указанные в нем права и обязанности,
                связанные с использованием Сайта.
            </p>


            <br>
            <p>
                <strong>1. Терминология</strong>
            </p>
            <p>
                1.1. <strong>Сайт </strong>-<strong> </strong>содержимое
                интернет-страниц,<strong> </strong>расположенных в сети интернет на
                домене<strong> </strong>http://www.vcv.ru
            </p>
            <p>
        1.2. <strong>Соискатель </strong>-<strong> </strong>пользователь Сайта,        <strong> </strong>вступающий в контакт с Работодателем с целью
                трудоустройства,<strong> </strong>либо<strong> </strong>потенциальный
                пользователь Сайта, зарегистрированный в базе Работодателя с целью
                дальнейшего контакта.
            </p>
            <p>
                1.3. <strong>Контактные данные Соискателя </strong>(резюме и/или
                Видеорезюме) –<strong> </strong>телефон для связи и адрес электронной
                почты (e’mail), указанный Соискателем.
            </p>
            <p>
                1.4. <strong>Учетные данные </strong>-<strong> </strong>уникальное имя
                пользователя<strong> </strong>(логин)<strong> </strong>и пароль для
                входа на защищенные страницы<strong> </strong>Сайта. В качестве
                уникального имени пользователя используется адрес электронной почты,
                указываемый Незарегистрированным пользователем при регистрации на
                Сайте.
            </p>
            <p>
        1.5. <strong>Учётная запись </strong>—<strong> </strong>запись,        <strong> </strong>содержащая сведения,<strong> </strong>которые
                Пользователь сообщает о себе Исполнителю.
            </p>
            <p>
                1.6. <strong>Работодатель </strong>–<strong> </strong>признаваемый в
        качестве работодателей действующим законодательством Российской        <strong> </strong>Федерации юридические лица, Индивидуальные
                предприниматели, адвокаты, нотариусы, а также, физические
            </p>
            <p>
                лица, вступающие в трудовые отношения с работниками в целях личного
                обслуживания и помощи по ведению домашнего хозяйства.
            </p>
            <p>
        1.7. <strong>Резюме </strong>—<strong> </strong>документ,        <strong> </strong>расположенный на Сайте и содержащий персональные
                данные Соискателя,<strong> </strong>включающий информацию о фамилии и
                имени, адресе электронной почты, образовании, описании мест работы,
                прочих данных относящихся к поиску работы и личности Соискателя,
                которые Соискатель указывает по своему усмотрению.
            </p>
            <p>
        1.8. <strong>Видеорезюме </strong>–<strong> </strong>видео файл,        <strong> </strong>созданный Соискателем,<strong> </strong>включающий в
                себя запись изображения и<strong> </strong>исполнения Соискателя и
                представляющий собой самопрезентацию Соискателя.
            </p>
            <p>
        1.9. <strong>Вакансия </strong>–<strong> </strong>документ,        <strong> </strong>содержащий информацию об основных критериях на
                вакантную должность у<strong> </strong>Работодателя, условиях работы,
                данные о Работодателе и иную информацию, которую Работодатель пожелал
                указать.
            </p>
            <p>
        1.10. <strong>Видеовакансия </strong>-<strong> </strong>видео файл,        <strong> </strong>созданный Работодателем,<strong> </strong>включающий
                в себя запись изображения и<strong> </strong>исполнения уполномоченного
                Работодателем лица и представляющий собой самопрезентацию Работодателя,
                описание вакансии и прочие данные, которые Работодатель пожелал
                сообщить.
            </p>
            <p>
        1.11. <strong>Виджет – </strong>совокупность программного обеспечения,<strong> </strong>содержащая модуль записи видеорезюме,        <strong> </strong>устанавливаемая путем копирования и внедрения
                специального программного кода на страницы внешнего сайта Заказчика с
                целью предоставления возможности Соискателям осуществлять запись
                видеорезюме непосредственно на сайте Заказчика.
            </p>
            <p>
        1.12. <strong>Приглашение на интервью - </strong>функция Сайта,<strong> </strong>позволяющая отправить по электронной почте Соискателю        <strong> </strong>приглашение пройти интервью, которое представляет
                собой видеозапись ответов Соискателя на вопросы
                Работодателя с помощью программного обеспечения Сайта. После
                прохождения Соискателем интервью Работодатель, отправивший приглашение,
                может просмотреть видео в Личном кабинете.
            </p>
            <p>
                1.13. <strong>Видеоотлик на вакансию - </strong>отклик Соискателя на
        Сайте на вакансию Работодателя,<strong> </strong>выполненный в виде        <strong> </strong>видеозаписи ответов на вопросы Работодателя.
            </p>
            <p>
        1.14. <strong>Интервью по запросу – </strong>это набор функций Сайта,<strong> </strong>позволяющий Заказчику направить личные        <strong> </strong>приглашения кандидатам (поиск и отбор которых
                Заказчик осуществил самостоятельно) для прохождения
                видеоинтервью на Сайте, а также позволяющий в дальнейшем просмотреть
                видеоотклики кандидатов.
            </p>
            <p>
        1.15. <strong>Незарегистрированный пользователь Сайта </strong>—<strong> </strong>физическое или юридическое лицо,<strong> </strong>не        <strong> </strong>зарегистрированное на Сайте, но использующее
                доступные для него сервисы Сайта.
            </p>
            <p>
                1.16. <strong>Пользователь Сайта </strong>-<strong> </strong>физическое
                или юридическое лицо,<strong> </strong>зарегистрированное на Сайте с
                целью<strong> </strong>использования сервисов и разделов Сайта при
                предварительном отборе кандидатов на собеседования.
            </p>
            <p>
                1.17. <strong>Личный кабинет </strong>–<strong> </strong>закрытая часть
                Сайта,<strong> </strong>на которую Пользователь сайта попадает посредством
                ввода<strong> </strong>своих регистрационных данных (логина и пароля) и
                получает доступ для редактирования и удаления персональных и других данных,
                совершения платежей, использования сервисов VCV.RU, и другая информация.
            </p>
            <p>
                1.18. <strong>Регистрация </strong>-<strong> </strong>процедура
                предоставления Незарегистрированным пользователем Сайта достоверной и
                полной информации о себе по вопросам, предлагаемым в форме регистрации, в
                результате которой для Пользователя будет создана уникальная учетная
                запись.
            </p>
            <p>
                1.19.
                <strong>Лицевой счет </strong>
                - счёт для ведения учета расчетов с Заказчиком,<strong> </strong>
                на котором отражаются все финансово-кредитные операции и услуги, оказанные
                Заказчику.<strong></strong>
            </p>
            <p>
                1.20. <strong>Исполнитель </strong>–<strong> </strong>Общество с
                ограниченной ответственность<strong> </strong>"Новые Информационные
                Системы",<strong> </strong>законный<strong> </strong>правообладатель и
            администратор Сайта в сети Интернет с адресом    <a href="http://www.vcv.ru/">www.vcv.ru.</a>
            </p>
            <p>
            1.21. <strong>Заказчик </strong>-<strong> </strong>Работодатель,    <strong> </strong>заказавший платные услуги и сервисы.
            </p>
            <p>
                1.22. <strong>Оплата </strong>–<strong> </strong>перечисление денежных
                средств в рублях РФ в счет оплаты Услуг Исполнителя путем<strong> </strong>
                безналичного перевода денежных средств на расчетный счет Исполнителя, а
                также оплата иным способом, разрешенным настоящим Договором и
                законодательством РФ.
            </p>


            <br>
            <p>
                <strong>2. Предмет Соглашения</strong>
            </p>
            <p>
                2.1. Сайт – это набор сервисов VCV, оказывающий содействие в
                предварительном отборе кандидатов для личных собеседований на вакансии
                работодателей и дальнейшем трудоустройстве с помощью функции «Интервью по
                запросу».
            </p>



            <br>
            <p>
                <strong>3. </strong>
                <strong>Исполнитель обязуется </strong>
                предоставлять Соискателю возможность откликаться на направленные
                Работодателем<strong> </strong>приглашения записать интервью (видеорезюме)
                с помощью программного обеспечения Сайта.<strong></strong>
            </p>



            <br>
            <p>
                <strong>4. </strong>
                <strong>Исполнитель вправе</strong>
            </p>
            <p>
                4.1. Исполнитель, а также привлекаемые им для осуществления отправки
                сообщений лица, в том числе Общество с ограниченной ответственности
                «ВИСИВИ», ОГРН 5177746185997, ИНН 7703436629, местонахождение: 123112, г.
                Москва, ул. Пресненская Набережная, д. 8, стр. 1, эт. 50, помещение 501С,
                вправе в любое время и без предварительного предупреждения направлять на
                адрес электронной почты Соискателя, предоставленный Работодателем,
                информационные сообщения о событиях компании Исполнителя, о сервисах Сайта
                и услугах Исполнителя и прочую информацию, включая рекламу, если Соискатель
                не отказался или не ограничил рассылку такого рода.
            </p>
            <p>
                4.2. Исполнитель, а также привлекаемые им для осуществления отправки
                сообщений лица, в том числе Общество с ограниченной ответственности
                «ВИСИВИ», ОГРН 5177746185997, ИНН 7703436629, местонахождение: 123112, г.
                Москва, ул. Пресненская Набережная, д. 8, стр. 1, эт. 50, помещение 501С,
                вправе в любое время и без предварительного предупреждения направлять на
                сотовый телефонный номер, предоставленный Работодателем, информационные
                сообщения (рассылка смс – сервис коротких сообщений) о событиях компании
                Исполнителя, о сервисах Сайта и услугах Исполнителя и прочую
                информацию, включая рекламу, если Соискатель не отказался или не ограничил
                рассылку такого рода.
            </p>
            <p>
                4.3. Исполнитель вправе изменять требования к содержанию и условиям
                публикации резюме/видеорезюме.
            </p>
            <p>
                4.4. Исполнитель оставляет за собой право модерации (редакторской
                обработки) резюме/видеорезюме в целях придания им качеств, удобных для
                читательского восприятия.
            </p>
            <p>
                4.5. Исполнитель оставляет за собой право не вступать в переписку с
                авторами резюме/видеорезюме.
            </p>
            <p>
                4.6. Исполнитель вправе в любое время по своему усмотрению без объяснения
                причин удалить резюме/видеорезюме или отказать в его размещении.
            </p>




            <br>
            <p>
                <strong>5. Соискатель обязуется</strong>
            </p>
            <p>
                5.1. Ознакомиться с условиями настоящего Соглашения.
            </p>
            <p>
                5.2. Не размещать, не распространять, не сохранять, не уничтожать, не
                загружать любым способом, посредством Сайта, информацию/материалы/видео в
                нарушение законодательства РФ и международного законодательства, в
                том числе, но не ограничиваясь:
            <ul>
            <br>
            <li>информацию, оскорбляющую нравственность, честь и достоинство, права и
                охраняемые законом интересы третьих лиц, нарушающую авторские и смежные
                права, пропагандирующую ненависть и/или дискриминацию людей по расовому,
                этническому, половому или социальному признакам, способствующую разжиганию
                религиозной, расовой или межнациональной розни, содержащую сцены насилия
                либо жестокого обращения с животными и т.д.;
            </li>
            <br>
            <li>
                информацию, содержащую компьютерные коды, предназначенные для нарушения,
                уничтожения либо ограничения функциональности любого компьютерного или телекоммуникационного
                оборудования или программ, для осуществления несанкционированного доступа,
                а также серийных номеров к коммерческим программным продуктам, логинов,
                паролей и прочих средств для получения несанкционированного доступа к
                платным ресурсам в Интернете;
            </li>
            <br>
            <li>
                информацию, содержащую
                пропаганду наркотических средств, психотропных веществ, алкоголя;
            </li>
            <br>
            <li>
                информацию, способную причинить вред, содержащую угрозы, грубые и
                оскорбительные выражения и предложения, противоречащие общепризнанным
                нормам морали, неправомерно используемую личную информацию третьих лиц
                (включая, но не ограничиваясь, упоминание любых адресов и телефонных
                номеров либо любой иной личной контактной информации без согласия владельца
                (персональных данных));
            </li>
            <br>
            <li>
                информацию порнографического либо эротического характера.
            </li>
            </ul>
            <p>
                5.3. Не размещать и/или передавать посредством Сайта информацию в виде
                текста, изображения, звука, видео или программного кода, которая может быть
                противозаконной, рекламой, угрожающей, оскорбительной, клеветнической,
                заведомо ложной, грубой, непристойной, вредить другим пользователям Сайта,
                нарушать их права и законные интересы.
            </p>
            <p>
                5.4. Не размещать и/или передавать, используя Сайт, материалы, в случае,
                если Соискатель не имеет на это соответствующих прав. Это касается
                материалов, защищенных авторским правом, торговыми марками, патентами,
                а также соглашениями о нераспространении информации, конфиденциальности и
                тому подобными.
            </p>
            <p>
                5.5. Не нарушать информационную безопасность Сайта.
            </p>
            <p>
                5.6. Не внедрять исполняемый код на стороне пользователя, любые внедряемые
                объекты, использовать frame и iframe, каскадные таблицы стилей, html-код.
            </p>
            <p>
                5.7. Не представляться чужим именем или от чужого имени (частного лица или
                организации), зарегистрированного на сайте Соискателя, представителя
                организации Работодателя, сотрудника Исполнителя. Не вводить в
                заблуждение пользователей и администрацию Сайта относительно своей
                идентификации любым иным способом.
            </p>
            <p>
                5.8. Не уничтожать и/или не изменять любые
                тексты/материалы/изображения/видео на Сайте, автором которых Соискатель не
                является.
            </p>
            <p>
                5.9. Не использовать информацию о телефонах, почтовых адресах, адресах
                электронной почты, любую другую персональную информацию для целей иных,
                нежели тематика сайта (поиск работы и сотрудников).
            </p>
            <p>
                5.10. Не регистрироваться, используя чужие учетные данные, на которые у
                Соискателя нет права использования.
            </p>
            <p>
                5.11. Не копировать и не использовать любым иным способом персональную
                информацию, кроме информации, содержащейся в резюме/видеорезюме, автором
                которого является Соискатель.
            </p>
            <p>
                5.12. Не размещать вакансии любых работодателей, а именно предложений о
                возможности трудоустройства у любых работодателей.
            </p>
            <p>
                5.13. Не размещать рекламу без согласования с Исполнителем; не размещать
                рекламные объявления, рекламирующие любые франчайзинговые или
                «пирамидальные» схемы, предлагающие «вступить в клуб», стать
                дистрибьютором, торговым представителем, «менеджером» или иным сотрудником
                компании, бизнес модель которой основана на предварительной и/или
                периодической передаче денежных средств от нижестоящих
                сотрудников вышестоящим, подразумевающую оплату труда только в виде
                процента от продаж и/или требующую привлечения или найма других агентов,
                дистрибьюторов, «менеджеров», «членов клуба» и тому подобное.
            </p>
            <p>
                5.14. Соискатель, соглашаясь с условиями настоящего соглашения, выражает
                свое полное и безоговорочное согласие получать от Исполнителя, а также от
                привлекаемых им для осуществления отправки сообщений лиц, в том числе
                Общества с ограниченной ответственностью «ВИСИВИ», ОГРН 5177746185997, ИНН
                7703436629, местонахождение: 123112, г. Москва, ул. Пресненская Набережная,
                д. 8, стр. 1, эт. 50, помещение 501С, информационные сообщения,
                предусмотренные п.4.1. , п.4.2. Соглашения.
            </p>
            <p>
                5.15. Соискатель самостоятельно несет ответственность перед третьими лицами
                за свои действия, связанные с использованием Сервиса, в том числе, если
                такие действия приведут к нарушению прав и законных интересов третьих лиц,
                а также за соблюдение законодательства при использовании Сайта.
            </p>





            <br>
            <p>
                <strong>6. Соискатель вправе</strong>
            </p>
            <p>
                6.1. Получить возможность пользоваться услугами Сайта, а именно: создавать
                отклики на вакансии в соответствии с настоящим Соглашением и действующим
                законодательством РФ.
            </p>
            <p>
                6.2. Обратиться к Исполнителю в целях получения консультации по техническим
                вопросам при размещении,
                использовании либо удалении резюме/видеорезюме.
            </p>
            <p>
                6.3. Отказаться или ограничить получение сообщений, предусмотренных п.4.1.
                настоящего Соглашения.
            </p>
            <p>
                6.4. Изменять и/или удалять информацию и данные, размещенные на Сайте,
                путем направления соответствующего требования Исполнителю.
            </p>







            <br>
            <p>
                <strong>7. Согласие на обработку персональных данных</strong>
            </p>
            <p>
                7.1. В соответствии с Федеральным законом от 27.07.2006 г. №152-ФЗ «О
                персональных данных» Соискатель путем (1) проставления символа «V» в
                соответствующем поле страницы Сайта в знак принятия обязательств по
                соблюдению настоящего Соглашения либо (2) перехода по ссылке
                выражения/подтверждения согласия, содержащейся в направленном Соискателю
                сообщении на адрес электронной почты с приглашением создать видеорезюме/
            иной информацией <strong>дает согласие Обществу с ограниченной ответственностью</strong>    <strong>«Новые</strong>
                <strong>
                    Информационные Системы», местонахождение: 121059, г.Москва, 1-й
                    Можайский тупик, дом 8 А, стр.1,осуществляющим на обработку своих
                    персональных данных в целях обеспечения соблюдения законодательства РФ,
                    содействия в трудоустройстве, заключения и исполнения настоящего
                    Соглашения.
                </strong>
            </p>
            <p>
                7.2. Соискатель соглашается разместить свои персональные данные в форме
                резюме/видеорезюме, необходимые для эффективного трудоустройства, а также
                выражает свое согласие на осуществление Исполнителем либо уполномоченным
                третьим лицом со всеми указанными в резюме/видеорезюме персональными
                данными, включая фото- видео- аудио материалы,
                следующих действий: сбор, запись, систематизация, накопление, хранение,
                уточнение (обновление, изменение), извлечение, использование, передачу
                (распространение, предоставление, доступ), обезличивание, блокирование,
                удаление, уничтожение, а также обработку (в том числе – автоматизированную)
                для целей исполнения Исполнителем своих обязательств по настоящему
                Соглашению, цели, указанной в п.2.1. настоящего Соглашения, а также для
                продвижения услуг Исполнителя в целях реализации настоящего Соглашения.
            </p>
            <p>
                7.3. Видеорезюме Соискателя используется Исполнителем для подтверждения
                принадлежности Соискателю полученных от него персональных данных в процессе
                использования Сайта. При использовании Видеорезюме Исполнитель в целях,
                определенных настоящим пунктом Соглашения, вправе применять технологию
                распознавания эмоций Соискателя.
            </p>
            <p>
                7.4. Соискатель соглашается, что Исполнитель имеет право обрабатывать
                персональные данные Соискателя, которые были им сделаны общедоступными
                путем размещения на сайтах, предназначенных для поиска работы.
            </p>
            <p>
                7.5. Срок размещения персональных данных неограничен и определяется
                самостоятельно владельцем персональных данных (Соискателем). Тем не менее,
                Исполнитель обрабатывает размещенные Соискателем персональные данные в
                течение срока, необходимого для достижения целей обработки персональных
                данных.
            </p>
            <p>
                7.6. Согласие на обработку персональных данных может быть отозвано
                Соискателем в любое время путем направления письменного заявления
                Исполнителю или иным способом, предусмотренным Политикой обработки
                персональных данных, размещенной на Сайте.
            </p>
            <p>
                7.7. При совершении Соискателем отклика на ту или иную вакансию от
                потенциального работодателя этой вакансии могут поступить вопросы,
                результаты ответов на которые остаются у этого работодателя и Соискателю не
                сообщаются. Ответы Соискателя на вопросы потенциального работодателя
                являются конфиденциальными. Вся ответственность за режим конфиденциальности
                ответов Соискателя лежит на соответствующем потенциальном работодателе.
            </p>
            <p>
                7.8. Ответственность за достоверность информации, содержащейся в
                резюме/видеорезюме, несет Соискатель.
            </p>
            <p>
                7.9. К публикации на Сайте не допускаются резюме/видеорезюме:
            </p>
            <p>
                1) Содержание которых нарушает законодательство Российской Федерации
                (содержащие пропаганду насилия, расовой ненависти, порнографию и пр.).
            </p>
            <p>
                2) Содержание которых нарушает общепринятые нормы морали и нравственности.
            </p>
            <p>
                3) Информация в которых противоречит правилам, определенным настоящим
                Соглашением и/или иными документами (договор, договор-оферта),
                расположенными на Сайте.
            </p>







            <br>
            <p>
                <strong>8. Размещение видеорезюме</strong>
            </p>
            <p>
                8.1. Исполнитель предоставляет Соискателю возможность бесплатного
                размещения видеорезюме на Сайте в качестве отклика Соискателя на Сайте на
                вакансию Работодателя, выполненного в виде видеозаписи ответов на вопросы
                Работодателя.
            </p>
            <p>
                8.2. Размещение осуществляется путем сохранения видеорезюме в общей базе
                данных Сайта и его отображения в Личном кабинете Работодателя, направившего
                приглашение.
            </p>
            <p>
                8.3. Соискатель соглашается с тем, что видеорезюме, размещаемое им на
                Сайте, может быть доступно для всех других пользователей, как
                непосредственно на Сайте, так и путем трансляции различными техническими
            </p>
            <p>
                средствами со ссылкой на первоначальный источник (с помощью почтовой
                рассылки, RSS-трансляции, использования в качестве электронной открытки,
                скринсейвера, записи в блоге и т.д.).
            </p>
            <p>
                8.4. В качестве имени автора при размещении видеорезюме на Сайте будет
                указываться имя Соискателя, которое он указал при регистрации в
                соответствующем разделе Сайта.
            </p>
            <p>
                8.5. Права на все размещенные на Сайте видеорезюме считаются принадлежащими
                разместившим их Соискателям до тех пор, пока не будет оснований считать
                иначе. Пользователи Сайта не получают никаких прав на
                использование видеорезюме других Пользователей вне рамок возможностей,
                предоставляемых Сайтом, и несут полную ответственность перед автором за
                неправомерное использование видеорезюме.
            </p>
            <p>
                8.6. Соискатель самостоятельно несет ответственность перед третьими лицами
                за свои действия, связанные с созданием и размещением видеорезюме на Сайте,
                в том числе за то, что содержание видеорезюме соответствует требованиям
                действующего законодательства и не нарушает права и законные интересы
                третьих лиц. Видеорезюме в целом и каждый из его элементов не должны
                нарушать авторские права, права на товарные знаки, средства
                индивидуализации и/или права на иные объекты интеллектуальной
                собственности, принадлежащие третьим лицам. Соискатель самостоятельно и за
                свой счет обязуется урегулировать все претензии третьих лиц, связанные с
                созданием и размещением видеорезюме на Сайте.
            </p>
            <p>
                8.7. Исполнитель имеет право без уведомления Соискателя и без объяснения
                причин не принимать видеорезюме к размещению на Сайте либо в любое время
                удалить видеорезюме с Сайта. В частности, основаниями для отказа в
                размещении или последующего удаления видеорезюме с Сайта являются:
            </p>
            <p>
                1) неправомерное использование в видеорезюме объектов, интеллектуальные
                права на которые принадлежат третьим лицам;
            </p>
            <p>
                2) размещение видеорезюме, нарушающих положения Соглашения;
            </p>
            <p>
                3) размещение видеорезюме эротического характера;
            </p>
            <p>
                4) размещение видеорезюме, содержащих элементы порнографии.
            </p>
            <p>
                8.8. Соискатель имеет право в любое время без объяснения причины закрыть
                доступ и/или удалить размещенное им видеорезюме с Сайта.
            </p>
            <p>
                8.9. Исполнитель не несет ответственности за использование (как
                правомерное, так и неправомерное) третьими лицами видеорезюме, размещенного
                на Сайте, включая его воспроизведение и распространение, осуществленные как
                в рамках Сайта, так и иными возможными способами.
            </p>
            <p>
                <strong>9. Информационная безопасность</strong>
            </p>
            <p>
                9.1. Вся информация, содержащаяся в поданных на Сайт резюме/видеорезюме,
                является общедоступной.
            </p>
            <p>
                9.2. Исполнитель прилагает все возможные усилия для того, чтобы избежать
                несанкционированного использования персональной информации Соискателей.
                Однако Исполнитель не несет ответственности за возможное нецелевое
                использование персональной информации Соискателей, произошедшее из-за:
            </p>
            <p>
                1) технических неполадок в программном обеспечении, серверах или
                компьютерных сетях, находящихся вне
                контроля Исполнителя;
            </p>
            <p>
                2) перебоев в работе Сайта, связанных с намеренным или ненамеренным
                использованием Сайта не по назначению третьими лицами,
            </p>
            <p>
                3) передачи любой информации с сайта Соискателями другим лицам, не
                являющимися зарегистрированными пользователями Сайта или другим
                пользователям, не имеющим доступа к данной информации в силу условий
                регистрации и заключенных договоров с Исполнителем.
            </p>
            <p>
                9.3. Используя Сайт, Соискатель соглашается и принимает, что Исполнитель
                оставляет за собой право использовать
                его персональную информацию анонимно и в обобщенном виде для статистических
                целей, а также для рекламных целей.
            </p>
            <p>
                9.4. Используя Сайт, Соискатель обязуется не нарушать информационную
                безопасность Сайта, что включает в себя:
            </p>
            <p>
                1) доступ к данным, не предназначенным для данного Соискателя или вход в
                систему под логином, не принадлежащем данному Соискателю;
            </p>
            <p>
                2) попытки проверить уязвимость системы безопасности Сайта, нарушение
                процедуры регистрации и авторизации без разрешения Исполнителя;
            </p>
            <p>
                3) попытки создать помехи в использовании Сайта другим пользователям, что
                включает в себя распространение компьютерных вирусов, порчу данных,
                постоянную рассылку повторяющейся информации, пересылку электронной почты
                через сервер сайта, одновременную отправку большого количества электронной
                почты и/или запросов к Сайту с целью намеренно вывести сервер Сайта из
                строя и тому подобные действия, выходящие за рамки нормального целевого
                использования Сайта, и могущие умышленно или по неосторожности повлечь сбои
                в его работе;
            </p>
            <p>
                4) рассылку пользователям Сайта материалов, на которые они не давали своего
                согласия, «спама», любых писем и рекламы без разрешения Исполнителя;
            </p>
            <p>
                5) имитацию и/или подделку любого заголовка пакета TCP/IP или любой части
                заголовка в любом электронном письме или размещенном на Сайте материале;
            </p>
            <p>
                6) использование или попытки использования любого программного обеспечения,
                или процедуры для навигации или поиску на Сайте, кроме встроенной в Сайт
                поисковой машины и традиционных и общедоступных браузеров
                (Microsoft Explorer, Mozilla Firefox и других подобных).
            </p>
            <p>
                9.5. Информация, содержащаяся на Сайте, не может быть воспроизведена,
                повторена и копирована, продана и перепродана, а также использована для
                каких-либо коммерческих целей без письменного разрешения Исполнителя.
            </p>
            <p>
                <strong>10. Услуги Сайта</strong>
            </p>
            <p>
                10.1. Все услуги Сайта, связанные с размещением резюме /видеорезюме и
                поиском вакансий, для Соискателей – бесплатны, если иное не установлено
                опубликованными на Сайте тарифами Исполнителя.
            </p>
            <p>
                10.2. Исполнитель по запросу Соискателя может предоставлять иные сервисы
                Сайта, в таком случае условия о содержании, порядке предоставления таких
                сервисов, цене или иного встречного предоставления размещаются на
                соответствующей странице Сайта.
            </p>
            <p>
                10.3. Исполнитель не является представителем ни Соискателей , публикующих
                на Сайте свои резюме/видеорезюме, ни Работодателей, размещающих вакансии,
                поэтому не может отвечать ни за какие договоренности, финансовые
                обязательства, возникающие между Соискателями и Работодателями.
            </p>
            <p>
                10.4. Исполнитель не гарантирует Соискателю, что вакансии, размещенные
                Работодателями на Сайте, либо любые предложения, сделанные Соискателю
                посредством Сайта, с использованием контактной информации, находящейся в
                базе данных Сайта, существуют на самом деле.
            </p>
            <p>
                10.5. Исполнитель не гарантирует, что опубликованные резюме/видеорезюме
                будут просмотрены определенным количеством пользователей Сайта или хотя бы
                одним.
            </p>
            <p>
                10.6. Исполнитель не гарантирует, что программное обеспечение, сервера и
                компьютерные сети, используемые Сайтом свободны от ошибок и компьютерных
                вирусов. Если использование Сайта повлекло за собой утрату данных или порчу
                оборудования Исполнитель не несет за это ответственности.
            </p>
            <p>
                10.7. Ни при каких обстоятельствах Исполнитель не несет ответственности за
                ущерб, убытки или расходы, возникшие в связи с использованием Сайта или
                невозможностью его использования.
            </p>
            <p>
                <strong>11. Использование материалов Сайта</strong>
            </p>
            <p>
                11.1. Каждый пользователь Сайта, Соискатель или Работодатель, отвечает за
                информацию, размещаемую от его имени и за последствия этого размещения.
                Размещая персональные данные Соискателей на Сайте и/или передавая их
                Исполнителю, Работодатель гарантирует, что имеет на это соответствующие
                права в соответствии с действующим законодательством РФ.
            </p>
            <p>
                11.2. Сайт является лишь средством для передачи информации и ни в коем
                случае не несет ответственности за ее достоверность и актуальность.
            </p>
            <p>
                11.3. Исполнитель прилагает все возможные усилия для того, чтобы исключить
                с Сайта небрежную, неаккуратную или заведомо ложную либо неполную
                информацию, однако, в конечном счете, ответственность за нее лежит на
                разместивших ее лицах.
            </p>
            <p>
                11.4. При перепечатке и ином использовании материалов Сайта, не являющихся
                резюме/видеорезюме Соискателей, описаниями компаний или вакансий, ссылка на
                Сайт обязательна.
            </p>
            <p>
                11.5. Использование Резюме Соискателей, описаний компаний и вакансий
                недопустимо ни с какими целями, кроме соответствующих тематике Сайта (поиск
                работы, сотрудников, получение информации о рынке труда).
            </p>
            <p>
                11.6. В случае, если Пользователь сохраняет резюме/видеорезюме Соискателя в
                своей собственной базе данных вне Сайта, то ответственность за это несет
                Пользователь Сайта в рамках Федерального закона №152-ФЗ от 27 июля 2006 г.
                «О персональных данных», как оператор персональных данных.
            </p>
            <p>
                11.7. Не допускается использование программных средств (скриптов, роботов)
                для считывания информации с Сайта.
            </p>
            <p>
                11.8. Логотип, название, элементы дизайна, оформления и общий внешний вид
                являются собственностью Исполнителя ООО «Новые Информационные Системы» и их
                использование запрещено.
            </p>
            <p>
                11.9. Поскольку идентификация пользователей интернет сайтов затруднена по
                техническим причинам, Исполнитель не отвечает за то, что зарегистрированные
                пользователи являются действительно теми людьми, за кого себя выдают, и не
                несет ответственности за возможный ущерб, причиненный Соискателям или
                другим лицам по этой причине.
            </p>
            <p>
                11.10. Используя информацию с Сайта, Соискатель осознает и принимает риски,
                связанные с возможной недостоверностью размещенной на Сайте информации, а
                также с тем, что некоторая информация может показаться ему угрожающей,
                оскорбительной, клеветнической, заведомо ложной, грубой, непристойной. Если
                это произошло, Соискатель должен немедленно прекратить использовать Сайт и
                сообщить Исполнителю о наличии подобной информации.
            </p>
            <p>
                <strong>12. Действие Соглашения</strong>
            </p>
            <p>
                12.1. Настоящее Соглашение действует с момента его акцепта Соискателем, то
                есть с момента проставления символа «V» в соответствующем поле страницы
                Сайта в знак принятия обязательств по соблюдению настоящего Соглашения.
            </p>
            <p>
                12.2. Исполнитель вправе в любое время по своему усмотрению и без
                предварительного согласования с Соискателем вносить изменения в настоящее
                Соглашение. В таком случае изменения и дополнения вступают в силу с момента
                их опубликования на Сайте.
            </p>
            <p>
                12.3. Ничто в настоящем соглашении не может пониматься как установление
                между Исполнителем и Соискателем агентских отношений, отношений по
                совместной деятельности, отношений личного найма, либо каких-то иных
                отношений, прямо не предусмотренных в настоящем Соглашением.
            </p>


            <br>


            <p>
                <strong>
                    Исполнитель Общество с ограниченной ответственностью «Новые
                    Информационные Системы»
                </strong>
            </p>
            <br>
            <p>
                Юридический адрес: 121059, г.Москва, 1-й Можайский тупик, дом 8А, стр.1
                ОГРН 1107746797102 ИНН 7707734464 КПП 773001001 р/сч 40702810938260017931 в
                ОАО «Сбербанк России» г. Москва к/с 30101810400000000225 БИК 044525225
            </p>
        </div>
        <div class="agreement" v-else>
            <h1>Privacy Policy </h1>
            <br>
            <p>
                <strong>Welcome to VCV Inc.’s (“VCV”) privacy policy. VCV respects your privacy and is committed to protecting your personal data.</strong>
            </p>
            <br>
            <p>
                <strong>1. Introduction</strong>
            </p>
            <p>
                This privacy policy tells you how VCV uses your personal data when you visit our website, interact with us, and use apps and our services.
            </p>
            <p>
                It also tells you about your privacy rights and how the law protects you.
            </p>

            <p>
                It is important that you read this privacy policy, together with any other privacy policies we may provide, so that you are fully aware of how and why we are using your data.
            </p>

            <p>
                This privacy policy was last updated on 14.06.2018 and historic versions can be obtained by contacting us.
            </p>

            <p>
                If you have any questions, or would like to exercise your privacy rights, please follow the instructions in this privacy policy. See How to contact VCV about privacy below.
            </p>

            <br>
            <p>
                <strong>2. Scope</strong>
            </p>

            <p>
                Our website, apps and services aimed at business users. This website is not intended for children under the age of majority in their jurisdiction and we do not knowingly collect data relating to children.
            </p>

            <br>
            <p>
                <strong>3. Personal data which we collect about you</strong>
            </p>

            <p>
                Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).
            </p>

            <p>
                We collect a variety of information about our users and visitors to the VCV website. This personal data falls into these categories:
            </p>

            <p>
                Identity Data includes title, first name, last name, username or similar identifier and your login/password. If you interact or login to our services with us through social media such as LinkedIn, this may include your user name.
            </p>
            <p>
                Contact Data includes billing address, email address and telephone numbers.
            </p>
            <p>
                Financial Data includes payment card details.
            </p>
            <p>
                Transaction Data includes details about payments to and from you and other details of services you have purchased from us.
            </p>
            <p>
                Profile Data includes your username and password, preferences, feedback and survey responses, as well as any profile data which we have added (for example, using analytics and profiling).
            </p>

            <p>
                Technical Data includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.
            </p>

            <p>
                Usage Data includes information about how you use our website, apps and services.
            </p>
            <p>
                Tracking Data includes information we or others collect about you from cookies and similar tracking technologies, such as mobile identifiers.
            </p>
            <p>
                We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose. Aggregated Data may be derived from your personal data but is not considered personal data in law as this data does not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate the percentage of users accessing a specific website feature. To provide better content and service, VCV’s website uses the Google Analytics web analytics service. Please see Google’s privacy for more information.  Google provides some additional privacy options described at http://www.google.com/policies/privacy/partners/ with respect to Google Analytics cookies. To opt out from Google Analytics, you can download a plug-in from <a href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>.
            </p>
            <p>
                However, if we combine or connect Aggregated Data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data which will be used in accordance with this privacy policy.
            </p>
            <p>
                We generally do not collect any Special Categories of Personal Data about you (this includes details about your religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health and genetic and biometric data). But as our chatbots talk with you, they may see and collect your race or ethnicity.
            </p>

            <br>
            <p>
                <strong>4. How is your personal data collected?</strong>
            </p>

            <p>
                We use different methods to collect data from and about you including through:
            </p>
            <p>
                Direct interactions. You may give us your Identity, Contact and Financial Data by filling in forms, using our services or by corresponding with us by phone, email or through chat or social media.
            </p>
            <p>
                This includes personal data you provide when you:
            </p>

            <ul>
                <br>
                <li>
                    create an account on our website;
                </li>
                <br>
                <li>
                    use our services;
                </li>
                <br>
                <li>
                    make inquiries or request information be sent to you;
                </li>
                <br>
                <li>
                    sign up to receive our newsletters;
                </li>
                <br>
                <li>
                    contact customer services.
                </li>
                <br>
            </ul>
            <p>
                Automated technologies or interactions. As you interact with us, including via the website, we may automatically collect Technical Data about your equipment, browsing actions and patterns. We may also collect Tracking Data when you use our website.
            </p>
            <p>
                Third parties or publicly available sources. We may receive personal data about you from various types of third parties, including:
            </p>

            <ul>
                <br>
                <li>
                    Technical Data and/or Tracking Data from analytics providers, and search information providers;
                </li>
                <br>
                <li>
                    Contact, Financial and Transaction Data from providers of payment and fraud prevention services.
                </li>
                <br>
            </ul>

            <br>
            <p>
                <strong>5. How we use your personal data</strong>
            </p>

            <ul>
                <br>
                <li>
                    Where we need to perform the contract we are about to enter into or have entered into with you. For example, when you purchase or signup to use our services, that’s a contract.
                </li>
                <br>
                <li>
                    Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests. For example, when we send you information that you have requested or to provide you with support you have requested.
                </li>
                <br>
                <li>
                    Where we need to comply with a legal or regulatory obligation. For example, keeping records of our sales for tax compliance.
                </li>
                <br>
            </ul>

            <p>
                Generally, we do not rely on consent as a legal basis for processing your personal data other than where the law requires it, for example in relation to automated decision-making. Our clients will develop the questions for the chatbot to ask job applicants and based on the applicant’s answers and the clients’ response categorizations, the chatbot determines if the applicant will move on to additional interviews.  Where our legal basis is consent, you have the right to withdraw consent any time but you may not be able to use all of our services as a result.
            </p>

            <p>
                See Explaining the legal bases we rely on to process personal data to find out more about the types of lawful basis that we will rely on to process your personal data.
            </p>

            <br>
            <p>
                <strong>6. Explaining the legal bases we rely on to process personal data</strong>
            </p>

            <p>
                Note that we may process your personal data for more than one lawful ground depending on the specific purpose for which we are using your data.
            </p>
            <p>
                If you ever have any questions about this, all you have to do is ask. See How to contact VCV about privacy below.
            </p>

            <br>
            <p>
                <strong>7. Advertising, marketing and your communications preferences</strong>
            </p>

            <p>
                We may use your Identity, Contact, Technical, Tracking, Usage and Profile Data to form a picture of what we think you may want or need, or what may be of interest to you. This is how we decide which services and offers may be relevant for you and tell you about them. This is what we call direct marketing.
            </p>
            <p>
                We may carry out direct marketing by email, phone, text or post. For example, you might have the newsletter hit your inbox.
            </p>
            <p>
                On our website, we always try hard to make it really clear what we are doing and what communications you will be sent, whether it’s you deciding to sign up to the newsletter or as part of creating an account or the purchase journey – and you have a right at any time to change your mind and say no thank you and opt out (but we’d be really sorry to see you go, so please gives us a chance by fine tuning your preferences before really leaving us!). The easiest way to opt out is to use the unsubscribe link at the bottom of the communication.
            </p>
            <p>
                Of course, there are lots of different ways you’ll see advertisements for VCV on other sites, and not all of these are based on using personal data – sometimes we just buy good old-fashioned advertising space in the real world and websites and social media. If you see VCV’s advertisements on websites, these may not be directed specifically at you, we might just have bid for the space. But here’s some things we may do that may be specifically directed at you:
            </p>

            <ul>
                <br>
                <li>
                    emails, for example the newsletter;
                </li>
                <br>
                <li>
                    text messages, for example with discount codes;
                </li>
                <br>
                <li>
                    promotions by post, such as great money off shipping offers, or from our trusted retail partners; and/or
                </li>
                <br>
                <li>
                    phone calls, to tell you something that might be relevant to you and your business.
                </li>
                <br>
            </ul>
            <p>
                We also work with partners to try and promote the reach of our advertisements and use analytics and retargeting for this reason. We use Tracking Data to deliver relevant online advertising, including via websites and social media.
            </p>
            <p>
                Tracking Data, and in particular cookies, help us to deliver website advertising that we believe is most relevant to you and to potential new customers of VCV.
            </p>
            <p>
                Cookies can also tell us if you have seen a specific advertisement, and how long it has been since you have seen it. This is helpful, because it means we can control the effectiveness of our advertisements and control the number of times people might be shown our advertisements (you know, before we risk become annoying). Cookies also help us understand if you’ve opened a marketing email because we don’t want to send you things you don’t read.
            </p>
            <p>
                If you want more information about Tracking Data, in particular cookies, see Cookies below.
            </p>
            <p>
                Almost all the cookies that relate to advertising are part of third party online advertising networks. If you’d like to read about how you can control which advertisements you see online, see opt-out programs established by the Digital Advertising Alliance (United States), the Digital Advertising Alliance of Canada and the European Interactive Digital Advertising Alliance. We do not control cookies which are set by advertising networks.
            </p>

            <br>
            <p>
                <strong>8. Cookies</strong>
            </p>

            <p>
                You can see from Advertising, marketing and your communications preferences above, that cookies are a tool which we (and everyone one else who operates online) uses for advertising. That is just part of why cookies are used. Generally, they are pretty clever.
            </p>
            <p>
                Cookies help our website and apps work better and provide lots of help in the background to make the process of being a VCV user a lot easier. You’d miss a lot of these things if they were gone – like it being easy to log in and move from page to page.
            </p>
            <p>
                Other cookies collect information about how visitors use our website, for instance which pages visitors go to most often, and if they get error messages from web pages. These cookies don't collect information that identifies a visitor. All information these cookies collect is aggregated and used to improve how our website works.
            </p>
            <p>
                There are also cookies that allow our website to remember choices you make (such as your user name, language or the region you are in) and provide enhanced, more personal features.
            </p>
            <p>
                There are cookies that collect information about your browsing habits in order to make advertising delivered to you more relevant to you and your interests (see Advertising, marketing and your communications preferences above). They are usually placed by advertising networks with our permission. They remember that you have visited a website and this information is shared with other organizations such as advertisers. Quite often targeting or advertising cookies will be linked to site functionality provided by the other organization.
            </p>
            <p>
                When you use our website, your device or browser may be sent cookies from third parties, for example when using embedded content and social network links. It's important for you to know that we have no access to or control over cookies used by these companies or third-party websites. We suggest you check the third-party websites for more information about their cookies and how to manage them.
            </p>
            <p>
                You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.
            </p>

            <br>
            <p>
                <strong>9. Disclosures of your personal data</strong>
            </p>

            <p>
                We may share your personal data with the parties set out below for the purposes set out in this privacy policy. We may also share your personal data if the law otherwise allows it.
            </p>
            <p>
                We may share personal data with the following categories third parties:
            </p>

            <ul>
                <br>
                <li>
                    Suppliers and service providers (such as technology service providers such as our hosting provider, payment processing and fraud prevention providers);
                </li>
                <br>
                <li>
                    auditors and professional advisers like bankers, lawyers, accountants and insurers; and
                </li>
                <br>
                <li>
                    our clients seeking to hire individuals- so they will be able to see your resume or CV videos on our website;
                </li>
                <br>
                <li>
                    government, regulators and law enforcement.
                </li>
                <br>
            </ul>

            <p>
                For example, we share personal data with the following specific third parties:
            </p>

            <ul>
                <br>
                <li>
                    AWS for hosting.  Please visit their privacy policy.
                </li>
                <br>
            </ul>
            <p>
                We also share data with third parties connected to advertising, retargeting and analytics. Please see Cookies above, including the cookie list, for more information about who those third parties are.
            </p>
            <p>
                We may also share data with third parties to whom we may choose to sell, transfer, or merge parts of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our business, then the new owners may use your personal data in the same way as set out in this privacy policy.
            </p>
            <p>
                We require all third parties to respect the security of your personal data and to treat it in accordance with the law. We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.
            </p>

            <br>
            <p>
                <strong>10. Payment information</strong>
            </p>

            <p>
                VCV uses third party payment processors to process payments made for services via the Website. All online payments will be conducted in accordance with Payment Card Industry (PCI) data security standards and your billing information (which is only used by these payment processors for the purpose of performing fraud protection) is encrypted before being communicated to them. Subject to the below exceptions, your credit card details are communicated directly from your browser to these payment processors - VCV does not see your full Permanent Account Number (PAN). This means that the payment form is either off-site or displayed in a frame on the payment page.
            </p>
            <p>
                For PayPal we only store the tokens required to identify the transaction with PayPal, issue refunds and identify transactions made using PayPal.
            </p>

            <br>
            <p>
                <strong>11. International transfers</strong>
            </p>

            <p>
                The information you enter on the website, apps or services or otherwise provide to VCV may be transferred outside of your country to the United States of America and other jurisdictions which does not offer an equivalent level of protection as in other parts of the world (i.e., as in the European Union). In particular, you are advised that the United States of America uses a sectoral model of privacy protection that relies on a mix of legislation, governmental regulation, and self-regulation. The European Union's General Data Protection Regulation (“GDPR”) allows for transfer of personal data from the European Union to a third country in certain situations. By agreeing to the terms of use and this Privacy Policy, you agree to the transfer of all such information to the United States of America which may not offer an equivalent level of protection to that required in other countries, particularly the European Union, and to the processing of that information by VCV on its servers located in the United States of America as described in this Privacy Policy. In our discretion, we may adopt other means, such as entering into Model Contract Clauses, or enter into different certification programs under applicable law for ensuring adequate safeguards.
            </p>

            <br>
            <p>
                <strong>12. Data security</strong>
            </p>

            <p>
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed, such as encryption, firewalls, password protection, third party audits and other internal restrictions. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.
            </p>
            <p>
                We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.
            </p>

            <br>
            <p>
                <strong>13. Data retention</strong>
            </p>

            <p>
                We will only keep your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements.
            </p>
            <p>
                To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements.
            </p>
            <p>
                By law we have to keep basic information about our customers (including Contact, Identity, Financial and Transaction Data) for a certain period of time after they stop being customers for tax purposes.
            </p>
            <p>
                In some circumstances you can ask us to delete your data; see Your legal rights below for further information.
            </p>
            <p>
                In some circumstances we may anonymize your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you.
            </p>

            <br>
            <p>
                <strong>14. Your legal rights</strong>
            </p>

            <p>
                If the General Data Protection Regulation applies to you because you are in the European Union, you have rights under data protection laws in relation to your personal data:
            </p>

            <ul>
                <br>
                <li>
                    The right to be informed – that’s an obligation on us to inform you how we use your personal data (and that’s what we’re doing that in this privacy policy);
                </li>
                <br>
                <li>
                    The right of access – that’s a right to make what’s known as a ‘data subject access request’ for copy of the personal data we hold about you;
                </li>
                <br>
                <li>
                    The right to rectification – that’s a right to make us correct personal data about you that may be incomplete or inaccurate;
                </li>
                <br>
                <li>
                    The right to erasure – that’s also known as the ‘right to be forgotten’ where in certain circumstances you can ask us to delete the personal data we have about you (unless there’s an overriding legal reason we need to keep it);
                </li>
                <br>
                <li>
                    The right to restrict processing – that’s a right for you in certain circumstances to ask us to suspend processing personal data;
                </li>
                <br>
                <li>
                    The right to data portability – that’s a right for you to ask us for a copy of your personal data in a common format (for example, a .csv file);
                </li>
                <br>
                <li>
                    The right to object – that’s a right for you to object to us processing your personal data (for example, if you object to us processing your data for direct marketing); and
                </li>
                <br>
                <li>
                    Rights in relation to automated decision making and profiling – that’s a right you have for us to be transparent about any profiling we do, or any automated decision making.
                </li>
                <br>
            </ul>
            <p>
                These rights are subject to certain rules around when you can exercise them. You can see a lot more information on them, if you are interested, on the UK Information Commissioner’s Office website.
            </p>
            <p>
                If you wish to exercise any of the rights set out above, please contact us (see How to contact VCV about privacy).
            </p>
            <p>
                You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances.
            </p>
            <p>
                We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.
            </p>
            <p>
                We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.
            </p>
            <p>
                We have appointed a data privacy manager who is responsible for overseeing questions in relation to this privacy policy. If you have any questions about this privacy policy, including any requests to exercise your legal rights, please contact the data privacy manager using the details in How to contact VCV about privacy below.
            </p>
            <p>
                You have the right to make a complaint at any time to the Information Commissioner's Office (“ICO”), the UK supervisory authority for data protection issues (www.ico.org.uk). We would, however, appreciate the chance to deal with your concerns before you approach the ICO so please contact us in the first instance.
            </p>

            <br>
            <p>
                <strong>15. How to contact VCV about privacy</strong>
            </p>

            <p>
                If you have any questions about this privacy policy, or would like to exercise any of your rights, please email us at <a href="mailto:support@vcv.ai">support@vcv.ai</a>.
            </p>

            <br>
            <p>
                <strong>16. A little request from VCV to you</strong>
            </p>

            <p>
                It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us. You can do this by updating your account. Thank you.
            </p>

            <br>
            <p>
                <strong>17. Changes to this privacy policy</strong>
            </p>

            <p>
                We may update our privacy policy from time to time. Be sure to check in and have read every now and then. Thank you.
            </p>
        </div>
  </div>
</template>

<script>
  export default {
    name: 'agreement',

    props: {
      lang: String
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.agreement {
  box-sizing: border-box;

  a {
    color: $green;
  }
}
</style>
